import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Menu } from '../../models';
import { MenuService } from '../../services';
import { Observable } from 'rxjs';

@Component({
  selector: 'mmg-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss']
})
export class SidenavMenuComponent implements OnInit {

  @Output() sidenavClose = new EventEmitter();

  readonly menu$: Observable<Menu[]>;

  constructor(
    private readonly menuService: MenuService
  ) {
    this.menu$ = this.menuService.menu$;
  }

  ngOnInit() {
    this.menuService.load();
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
  }

}